var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"font-sans h-full flex flex-col"},[_c(_setup.TopNavigation),_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c(_setup.MessageToaster)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }